import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Card, Typography, useThemeValue } from '@altermaind/web/ui';
import { LayoutContext } from '@/_shared/components';
import { Routes } from '@/_shared/constants/routes';
import { useSurvey } from '@/surveys';
import { postEmployerByIdSurveyResultCall } from '@/surveys/state/api';

export const ConversationsScreen = () => {
  const t = useTranslations('conversations');
  const navigate = useNavigate();
  const { setLayout } = useContext(LayoutContext);

  const gapS = useThemeValue('space', 's');

  const primary = useThemeValue('colors', 'primary');

  const { response: responsePostEmployerByIdSurveyResult } =
    postEmployerByIdSurveyResultCall.hook();

  const { softSkillTemplate } = useSurvey();

  const goToConversation = () => {
    const resultsSurvey = responsePostEmployerByIdSurveyResult?.find(
      survey =>
        survey.completed === true &&
        survey.canViewResults === true &&
        survey.templateName === softSkillTemplate.name,
    );

    navigate(Routes.Conversation.replace(':conversationId', '1'), {
      state: {
        initialPrompt: `Sei un assistente AI per la piattaforma SaaS di Slash. Il tuo nome è Federica e puoi rispondere SOLO per dare i risultati della Survey fatta. Basati su questi dati: ${resultsSurvey?.results?.insights}. Metriche ottenute: ${resultsSurvey?.results?.results?.map(metric => `${metric.metric?.name}: ${metric.score}`).join(', ')}.`,
      },
    });
  };

  useEffect(() => {
    setLayout({ title: 'conversations' });
  }, [setLayout, t]);

  return (
    <Box>
      <Box mb='m'>
        <Typography variant='h1' mb='xxxs'>
          {t('title')}
        </Typography>
        <Typography variant='p3/light' mb='xs'>
          {t('description')}
        </Typography>
      </Box>
      <Box
        display='grid'
        gridTemplateColumns='repeat(auto-fill, minmax(250px, 1fr))'
        style={{ gap: gapS }}
      >
        <Card p='xxxs' minHeight='200px'>
          <Box
            background={`conic-gradient(from 120deg at 25% 40%, rgba(27, 33, 41, 1) 0deg, ${primary} 300deg)`}
            borderRadius='l'
            height={200}
            display='flex'
            flexDirection='column'
            justifyContent='space-between'
          >
            <Box
              display='flex'
              flexDirection='row'
              justifyContent='space-between'
              alignItems='center'
              ml='xs'
              mr='xs'
              mt='xs'
            >
              <Box />
            </Box>
            <Typography mb='xs' ml='xs' variant='h2'>
              {t('example.title')}
            </Typography>
          </Box>
          <Box p='xxs'>
            <Typography variant='p3/light' minHeight='80px'>
              {t('example.description')}
            </Typography>
            <Button onClick={goToConversation} mt='s' variant='primary'>
              {t('example.buttonLabel')}
            </Button>
          </Box>
        </Card>
      </Box>
    </Box>
  );
};
